<template>
<div>
  <div v-if="list.length>0">
  <div v-for="(item,index) in list" :key="index" class="listinr">
    <span class="tidahe">{{item.createTime| dateformat('YYYY-MM-DD HH:mm')}}</span>
    <div class="duihrnnr" @click="hgoeonr">
      <div style="display: flex;">
        <img :src="item.pic" alt="">
        <div style="height:0.84rem;display: flex;flex-direction: column;justify-content: space-between; align-items: flex-start;margin-left: 0.3rem">
          <span style="font-size: 0.28rem;color: #333333;font-weight: bold;">{{item.prodName}}</span>
          <span style="color: #3A3A3A;font-size: 0.28rem">-{{item.pointsNumber}}积分</span>
        </div>

      </div>
      <md-icon name="arrow-right" size="md"></md-icon>
    </div>
  </div>
  </div>
  <div v-else style="width: 100%;height: 3rem;display: flex;justify-content: center;align-items: center;font-size: 0.4rem">
    <span>暫無數據</span>
  </div>
</div>
</template>

<script>
import {Toast} from "mand-mobile";
import {getUrlKey} from "@/until/getUrlcode";
import wx from "weixin-js-sdk";

export default {
name: "duihuanlist",
  data(){
  return{
    list:[]
  }
  },
  activated() {
    Toast.loading('请稍等...')
    this.getExchangeHistory()
  },
  methods:{
    getExchangeHistory(){
      this.ajax.AJAx(this.ports.getExchangeHistory, 'post').then(res => {
        this.list=res
        Toast.hide();
      }).catch(err => {
        Toast.hide();
        this.loading=false;
      })
    },
    hgoeonr(){
      this.$router.push({name:'Coup'})
    }
  },
}
</script>

<style scoped lang="less">
.listinr{
  width: 94%;
  margin-left: 3%;
  margin-top: 0.2rem;
  background-color: white;
  height: 2.3rem;
  display: flex;
  flex-direction: column;
  align-items: self-start;
  .tidahe{
    font-size: 0.28rem;
    color: #999999;
    margin: 5%;
  }
  .duihrnnr{
    width: 90%;
    display: flex;
    margin-left: 5%;
    justify-content: space-between;
    align-items: center;
    img{
      width: 0.84rem;
      height: 0.84rem;
    }
  }
}
</style>
